// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header_container__vI36D {
    position: sticky;
    top: 0;
    right: 0;
    left: 0;
    width: 100%;
    padding-top: 25px;
    padding-bottom: 25px;
    box-shadow: 0 4px 24px rgba(28, 35, 43, 0.25);
    background-color: #FFF;
    z-index: 2;
}

.Header_header-content__4zuFr {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.Header_header-logo__dfVwh {
    font-size: 3rem;
    cursor: pointer;
}

.Header_header-logo__dfVwh span {
    color: var(--green-main);
}

.Header_header-menu__kT3eK ul li {
    display: inline-flex;
    margin-right: 60px;
    font-size: 20px;
    list-style: none;
}

.Header_header-menu__kT3eK ul li:last-child {
    margin-right: 0;
}

.Header_header-menu__kT3eK ul li a {
    cursor: pointer;
    text-decoration: none;
    color: var(--black-text);
}

.Header_control-select-lng__nPOz- {
    font-family: "Tenorite", sans-serif;
}

.Header_control-select-lng__nPOz- button {
    border: none;
    font-size: 20px !important;
}

.Header_control-select-lng__nPOz- button::after,
.Header_control-select-lng__nPOz- button[aria-expanded="true"]::after{
    display: none;
}

.Header_control-select-lng__nPOz- ul {
    padding: 0;
    border: 1px solid rgba(0, 0, 0, .1);
    font-size: 20px !important;
}


@media screen and (max-width: 1440px) {
    .Header_header-logo__dfVwh {
        font-size: 2.7rem;
    }

    .Header_header-menu__kT3eK ul li {
        font-size: 18px;
    }
}

@media screen and (max-width: 992px) {
    .Header_header-logo__dfVwh {
        font-size: 2.4rem;
    }

    .Header_header-menu__kT3eK ul li {
        margin-right: 40px;
    }
}

@media screen and (max-width: 768px) {
    .Header_header-menu__kT3eK {
        display: none;
    }
}

@media screen and (max-width: 576px) {
    .Header_header-logo__dfVwh {
        font-size: 2.2rem;
    }

    .Header_btn-schedule__rnirP {
        display: none;
    }
}

@media screen and (max-width: 480px) {
    .Header_header-logo__dfVwh {
        font-size: 2rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Header/Header.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,MAAM;IACN,QAAQ;IACR,OAAO;IACP,WAAW;IACX,iBAAiB;IACjB,oBAAoB;IACpB,6CAA6C;IAC7C,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,mCAAmC;IACnC,0BAA0B;AAC9B;;;AAGA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ","sourcesContent":[".container {\n    position: sticky;\n    top: 0;\n    right: 0;\n    left: 0;\n    width: 100%;\n    padding-top: 25px;\n    padding-bottom: 25px;\n    box-shadow: 0 4px 24px rgba(28, 35, 43, 0.25);\n    background-color: #FFF;\n    z-index: 2;\n}\n\n.header-content {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.header-logo {\n    font-size: 3rem;\n    cursor: pointer;\n}\n\n.header-logo span {\n    color: var(--green-main);\n}\n\n.header-menu ul li {\n    display: inline-flex;\n    margin-right: 60px;\n    font-size: 20px;\n    list-style: none;\n}\n\n.header-menu ul li:last-child {\n    margin-right: 0;\n}\n\n.header-menu ul li a {\n    cursor: pointer;\n    text-decoration: none;\n    color: var(--black-text);\n}\n\n.control-select-lng {\n    font-family: \"Tenorite\", sans-serif;\n}\n\n.control-select-lng button {\n    border: none;\n    font-size: 20px !important;\n}\n\n.control-select-lng button::after,\n.control-select-lng button[aria-expanded=\"true\"]::after{\n    display: none;\n}\n\n.control-select-lng ul {\n    padding: 0;\n    border: 1px solid rgba(0, 0, 0, .1);\n    font-size: 20px !important;\n}\n\n\n@media screen and (max-width: 1440px) {\n    .header-logo {\n        font-size: 2.7rem;\n    }\n\n    .header-menu ul li {\n        font-size: 18px;\n    }\n}\n\n@media screen and (max-width: 992px) {\n    .header-logo {\n        font-size: 2.4rem;\n    }\n\n    .header-menu ul li {\n        margin-right: 40px;\n    }\n}\n\n@media screen and (max-width: 768px) {\n    .header-menu {\n        display: none;\n    }\n}\n\n@media screen and (max-width: 576px) {\n    .header-logo {\n        font-size: 2.2rem;\n    }\n\n    .btn-schedule {\n        display: none;\n    }\n}\n\n@media screen and (max-width: 480px) {\n    .header-logo {\n        font-size: 2rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Header_container__vI36D`,
	"header-content": `Header_header-content__4zuFr`,
	"header-logo": `Header_header-logo__dfVwh`,
	"header-menu": `Header_header-menu__kT3eK`,
	"control-select-lng": `Header_control-select-lng__nPOz-`,
	"btn-schedule": `Header_btn-schedule__rnirP`
};
export default ___CSS_LOADER_EXPORT___;
